var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{on:{"click":_vm.initEditPoll}},[_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-poll-h"}),_vm._v(" "+_vm._s(_vm.translations['fields.edit'])+" poll ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }